import type { Router } from 'vue-router'
import NProgress from 'nprogress'
import i18n from '@/locales'
import { useUserStore } from '@/stores/user'
import { useAuthModalStore } from '@/stores/authModal'

NProgress.configure({ showSpinner: false, trickleSpeed: 200 })

function translateKey(key: string): string {
  if (!key) return ''
  const t = i18n.global.t as (k: string) => string
  return i18n.global.te(key) ? t(key) : key
}

function updateTitle(titleKey?: string): void {
  const base = import.meta.env.VITE_APP_TITLE || 'DeskoWebStore'
  if (titleKey) {
    document.title = `${translateKey(titleKey)} | ${base}`
  } else {
    document.title = base
  }
}

export function setupRouterGuard(router: Router): void {
  router.beforeEach(async (to, _from, next) => {
    NProgress.start()
    updateTitle(to.meta.title)

    const userStore = useUserStore()

    // 需要登录但未登录时，打开登录弹窗
    if (to.meta.requiresAuth && !userStore.isLoggedIn) {
      const authModal = useAuthModalStore()
      authModal.open({ mode: 'login', redirect: to.fullPath })
      if (_from.name) {
        next(false)
      } else {
        next({ path: '/', replace: true })
      }
      NProgress.done()
      return
    }

    next()
  })

  router.afterEach(() => {
    NProgress.done()
  })
}
